export const getGradeFromValue = (value) => {
    if (value === null || value === undefined) {
        return undefined
    }
    return (1 - value) * 10
}